import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { User } from "../../models/user.model";
import { AccountService } from "../../services/account.service";

@Component({
  selector: "up-logged-user-avatar",
  templateUrl: "./logged-user-avatar.component.html",
  styleUrls: ["./logged-user-avatar.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoggedUserAvatarComponent implements OnInit {
  user?: User | null;

  sharedStyle!: Object;

  @Input() fontSize: string = "14px";
  @Input() size: number = 40;
  @Input() shape: "circle" | "square" = "circle";

  constructor(private _accountService: AccountService) {}

  async ngOnInit() {
    if (this.size % 2 != 0)
      throw new Error("LoggedUserAvatarComponent - Size must be even");

    // TOD WL: Verificar se ao fazer update do user e fazer o "me" se já vai ajustar
    this._accountService.loggedUserUpdated.subscribe((_) => this.setUser());

    await this.setUser();

    this.sharedStyle = {
      "background-color": "#e1e1e1",
      height: this.size + "px",
      width: this.size + "px",
      "border-radius": this.shape == "circle" ? this.size / 2 + "px" : 0,
    };
  }

  async setUser() {
    this.user = await this._accountService.me();
  }
}
